export const theme = {
  background: '#FCFCFC',
  backgroundLight: '#FFFFFF',
  backgroundDark: '#F3F4F6',
  text: '#111111',
  textLight: '#111111',
  textDark: '#4B5563',
  accent: '#000000',
  accentLight: 'rgba(0, 0, 0, 0.05)',
  accentDark: 'rgba(0, 0, 0, 0.1)',
  primary: '#000000',
  secondary: '#374151',
  lightGray: '#F9FAFB',
  darkGray: '#E5E7EB',
  white: '#FFFFFF',

  fontPrimary: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  fontMono: "'Fira Code', 'IBM Plex Mono', monospace",

  transition: 'all 0.5s cubic-bezier(0.19, 1, 0.22, 1)',
  borderRadius: '16px', 
  cardShadow: '0 10px 40px rgba(0, 0, 0, 0.04)',
  cardBorder: '1px solid rgba(0, 0, 0, 0.05)',
  navHeight: '80px',
};

export const lightTheme = theme;
export const darkTheme = theme;
